import React from "react";
import Meta from "../components/global/meta";
import Four0Four from "../components/404";
import Loader from "../components/global/loader";
import PageComponent from "../components/cms/blocks/pageComponent";
import { useCms } from "../hooks/useCms";
import { GlobalStore } from "../stores/global";
import HeroMain from "../components/global/heroMain";
import HeroComponentV4 from "../components/global/heroV4";

export default function Home() {
  const { header, meta, title } = GlobalStore.useState(c => c);
  const cmsContent = useCms();
  const closeTopBanner = GlobalStore.useState(s => s.closeTopBanner);

  if (!header) return <Loader withMargins />;
  if (!header || cmsContent === null) return <Four0Four />;

  return (
    <div id="home" className={`${closeTopBanner ? "closeBanner" : ""}`}>
      {meta && title && <Meta title={title} seo={meta.seo} />}
      <div className="centralContainer">
        {header.__typename === "ComponentPageHeroV4" && <HeroComponentV4 content={header} />}
        {header.__typename === "ComponentPageHero" && <HeroMain content={header} />}
        {cmsContent ? <PageComponent components={cmsContent.content} isHome={true} /> : <Loader withMargins />}
      </div>
    </div>
  );
}
